const actionKeys = {
  bump: 'BumpTaskRefresh',
};

const bump = () => async (dispatch) => {
  dispatch({
    type: actionKeys.bump,
  });
};

const reducer = (state = {value: 0}, action) => {
  switch (action.type) {
    case actionKeys.bump:
      return {
        ...state,
        value: state.value + 1,
      };
    default:
      return state;
  }
};

export default {
  actions: {
    bump,
  },
  reducer: reducer,
  defaultState: {
    value: 0,
  },
};
